import { lastElement } from "../../../helpers";
import getSeatNamesFromNumberOfSeats from "../../Shared/functions/getSeatNamesFromNumberOfSeats";

const isCheckAnAvailableAction = (spot, scenario, seats) => {
	return spot && scenario === "flmp" && lastElement(spot.split(",")) === lastElement(getSeatNamesFromNumberOfSeats(seats));
};

export default isCheckAnAvailableAction;
